import { createSlice } from '@reduxjs/toolkit'

export const formsSlice = createSlice({
  name: 'forms',
  initialState: {
    value: {}
  },
  reducers: {
    addForm: (state, data) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.value[data.payload.name] = data.payload.form
    },
    removeForm: (state, formId) => {
      delete state.value[formId]
    }
  },
})

// Action creators are generated for each case reducer function
export const { addForm, removeForm } = formsSlice.actions

export default formsSlice.reducer